import React from 'react';
import { PokerFaceSpecialOfferButton } from './style';
import { ActualPrice } from 'components/BundlePrice/ActualPrice';
import { BundlePriceProps } from 'utils/types';

export const PokerFaceSpecialOfferPrice: React.FC<BundlePriceProps> = ({
  prices,
  buttonColor,
  borderColor,
  buttonTextColor,
  isFree,
  buttonText = 'Collect',
}) => {
  return (
    <PokerFaceSpecialOfferButton
      backgroundColor={buttonColor}
      textColor={buttonTextColor}
      borderColor={borderColor}
    >
      <div className="container">
        {isFree ? (
          <span>{buttonText}</span>
        ) : (
          <ActualPrice prices={prices} textShadow="0 2px 1px #004100" />
        )}
      </div>
    </PokerFaceSpecialOfferButton>
  );
};
